export default __webpack_public_path__ + "media/images/front/municipality_collaboration/bus-02201f320b3689181a43fc27d4ae9089.png";